import { Button, DatePicker, Form, InputNumber, Select, Space } from "antd";
import { useEffect, useState } from "react";
import AddIcon from "../../../assets/icons/AddIcon";
import DateIcon from "../../../assets/icons/DateIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import CustomModal from "../../../components/ui/CustomModal";
import { employeeTypeList } from "../../../constants/constants";
import { useGetDepartmentsQuery } from "../../../features/department/departmentApi";
import { useGetDesignationsQuery } from "../../../features/designation/designationApi";
import { useGetEmployeesQuery } from "../../../features/employee/employeeApi";
import { useGetPayrollSettingQuery } from "../../../features/payrollSetting/payrollSettingApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import { ListComponentType } from "../../../pages/admin/Settings/Payroll/AdditionsModal";
import { PayComponentModalType } from "../../../pages/admin/Settings/Payroll/PayComponents";
import { ModalComponentProps } from "../../../types";
import {
  convertToSnakeCase,
  selectArrayOption,
  selectSearchOption,
} from "../../../utils/utils";

type Props = {
  handleDataList: (data: any, type: "ADD" | "EDIT" | "DELETE") => void;
  amountData: any;
} & ModalComponentProps<any, PayComponentModalType>;

export default function CustomAmountModal({
  handleClose,
  data: componentItem,
  type,
  handleDataList,
  amountData,
  ...rest
}: Props) {
  const [form] = Form.useForm();

  const {
    data: salaryData,
    isLoading: isSalaryLoading,
    isError: isSalaryError,
    error: salaryError,
  } = useGetPayrollSettingQuery();
  useError(isSalaryError, salaryError, "Get salary breakdown data fail");

  const [sData, setSData] = useState<any>();

  useEffect(() => {
    if (salaryData) {
      setSData([
        ...(typeListCalculationSelect || []),
        ...(salaryData?.data?.payroll_setting?.salary_breakdown
          ?.filter((item) => item?.is_active)
          ?.map((item) => ({
            label: `% of ${item?.title}`,
            value: item?.key,
          })) || []),
      ]);
    }
  }, [salaryData]);

  const onFinish = (values: any) => {
    const packageList = values?.package?.map((item: any, index: number) => {
      const packageName = `Package ${componentItem + index + 1}`;
      const target = item[`target-${item["effective_for"]}`] || undefined;

      return {
        ...item,
        target: target ? [target] : undefined,
        amount:
          item?.on_what === "fixed_amount"
            ? Number(item?.fixed_amount)
            : item?.amountPercentage,
        schedule_date: item?.fixed_date_time
          ? item?.fixed_date_time?.month() + 1
          : null,
        schedule_year: item?.fixed_date_time
          ? item?.fixed_date_time?.year()
          : undefined,
        calculation_type: "fix_pay_amount",
        is_percentage: item?.on_what === "fixed_amount" ? 0 : 1,
        name: packageName,
        key: convertToSnakeCase(packageName),
        periodic_schedule: 1,
        is_active: 1,

        "target-department": undefined,
        "target-designation": undefined,
        "target-employee_type": undefined,
        "target-employee": undefined,
        fixed_date_time: undefined,
        fixed_amount: undefined,
        amountPercentage: undefined,
      };
    });

    const { editId, ...rest } = amountData;

    const newData = {
      ...rest,
      package: packageList,
    };

    if (type === "ADDITION_ADD" || type === "DEDUCTION_ADD") {
      handleDataList(newData, "ADD");
      toast("success", "Pay components successfully added!");
      handleClose();
    } else if (type === "ADDITION_EDIT" || type === "DEDUCTION_EDIT") {
      handleDataList(
        {
          ...newData,
          id: editId,
        },
        "EDIT"
      );
      toast("success", "Pay components successfully updated!");
      handleClose();
    }
  };

  // useEffect(() => {
  //   if (isCreateSuccess) {
  //     toast("success", "Overtime setting updated successfully");
  //     handleClose();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isCreateSuccess]);

  return (
    <CustomModal
      {...rest}
      title="Custom Amount"
      handleClose={handleClose}
      maskClosable={false}
      footer={null}
      width={900}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="flex items-center justify-end mb-2">
          {/* <h3 className="text-header text-[22px] font-semibold">
              Tax Setting
            </h3> */}
          <label
            htmlFor="add-unpaid-leave"
            className="outline-button-primary border flex items-center py-1.5 px-2 cursor-pointer gap-1 rounded"
          >
            <AddIcon />
            <span>Add More</span>
          </label>
        </div>
        <Form.List initialValue={[undefined]} name="package">
          {(fields, { add, remove }) => {
            return (
              <>
                <button
                  className="sr-only"
                  id="add-unpaid-leave"
                  onClick={() => add()}
                  type="button"
                >
                  Add
                </button>
                {fields?.map((field, index) => (
                  <div
                    className={`flex justify-between items-center flex-wrap pt-2 pb-2 px-3 py-1 bg-[#fbfcfd] border border-light attendance-table ${
                      index === 0 ? "border-t" : "border-t-0"
                    }`}
                    key={field.key}
                  >
                    <div>
                      <div className="sr-only">
                        <Form.Item className="mb-0" name={[index, "id"]} />
                      </div>
                      <div className="flex items-center gap-2.5 ">
                        <span className="text-display-body text-sm font-medium sr-only">
                          Effective For
                        </span>
                        <Form.Item
                          validateFirst
                          name={[index, "effective_for"]}
                          className="mb-0 sr-only"
                          rules={[
                            {
                              required: true,
                              message: "Please select",
                            },
                          ]}
                          initialValue={"employee"}
                        >
                          <Select
                            className="w-full"
                            // suffixIcon={<SelectDropdownLgIcon />}
                            options={effectiveForList}
                            // loading={isSalaryLoading}
                            style={{ width: 150 }}
                            size="small"
                            placeholder="Select"
                          />
                        </Form.Item>
                        <EffectiveFor index={index} form={form} />

                        <span className="text-display-body text-sm font-medium">
                          Select Component
                        </span>
                        <Form.Item
                          validateFirst
                          name={[index, "on_what"]}
                          className="mb-0"
                          rules={[
                            {
                              required: true,
                              message: "Please select component",
                            },
                          ]}
                          initialValue={"fixed_amount"}
                        >
                          <Select
                            className="w-full"
                            options={sData}
                            loading={isSalaryLoading}
                            style={{ width: 155 }}
                            popupMatchSelectWidth={180}
                            size="small"
                            placeholder="Select"
                          />
                        </Form.Item>
                        <CalculateType index={index} form={form} />
                      </div>
                      <div className="flex items-center gap-2.5">
                        <span className="text-display-body text-sm font-medium">
                          Schedule Type
                        </span>
                        <Form.Item
                          validateFirst
                          name={[index, "schedule_type"]}
                          className="mb-0"
                          rules={[
                            {
                              required: true,
                              message: "Please select",
                            },
                          ]}
                          initialValue={"fixed_date"}
                        >
                          <Select
                            className="w-full"
                            options={scheduleTypeList}
                            style={{ width: 130 }}
                            popupMatchSelectWidth={180}
                            size="small"
                            placeholder="Select"
                          />
                        </Form.Item>
                        <ScheduleType index={index} form={form} />
                      </div>
                    </div>

                    <Button
                      className="action-button"
                      size="small"
                      icon={<DeleteIcon />}
                      onClick={() => {
                        remove(field.name);
                      }}
                    />
                  </div>
                ))}
              </>
            );
          }}
        </Form.List>

        <Space className="w-full pt-6 justify-end" size={12}>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
          >
            Save
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}

const CalculateType = ({ index, form }: ListComponentType) => {
  const onWhat = Form.useWatch(["package", index, "on_what"], form);

  return onWhat === "fixed_amount" ? (
    <>
      <span className="text-display-body text-sm font-medium">Amount</span>

      <Form.Item
        validateFirst
        name={[index, "fixed_amount"]}
        // label="Enter Amount"
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please enter amount",
          },
          {
            type: "number",
            min: 0,
            message: "Amount cannot be negative",
          },
          {
            validator: async (_: any, value: string) => {
              if (!value) {
                return Promise.resolve();
              }

              if (value?.toString().length > 9) {
                return Promise.reject(
                  new Error("Amount cannot exceed 9 digits")
                );
              }
            },
          },
        ]}
      >
        <InputNumber
          placeholder="0.00"
          type="number"
          //   className="w-full"
          prefix="BDT"
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              e.preventDefault();
            }
          }}
          onWheel={(e) => {
            e.preventDefault();
            (e.target as HTMLElement).blur();
          }}
          keyboard={false}
          controls={false}
          style={{ width: 110 }}
          size="small"
        />
      </Form.Item>
    </>
  ) : (
    <>
      <span className="text-display-body text-sm font-medium">Percentage</span>
      <Form.Item
        validateFirst
        name={[index, "amountPercentage"]}
        // label="Enter Percentage"
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please enter percentage",
          },
          {
            type: "number",
            min: 0,
            message: "Percentage cannot be negative",
          },
          {
            type: "number",
            max: 100,
            message: "Percentage can not be more than 100%",
          },
        ]}
      >
        <InputNumber
          placeholder="Value"
          type="number"
          // size="middle"
          className="w-full"
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              e.preventDefault();
            }
          }}
          onWheel={(e) => {
            e.preventDefault();
            (e.target as HTMLElement).blur();
          }}
          controls={false}
          style={{ width: 80 }}
          // suffix={<PercentageIcon />}
          size="small"
        />
      </Form.Item>
    </>
  );
};

const EffectiveFor = ({ index, form }: ListComponentType) => {
  const effective = Form.useWatch(["package", index, "effective_for"], form);
  const {
    isLoading: isEmployeeLoading,
    isError: isEmployeeError,
    error: employeeError,
    data: employeeData,
  } = useGetEmployeesQuery({
    params: {
      status: "active",
      skip: 0,
      limit: 0,
    },
  });
  const {
    isLoading: isDepartmentLoading,
    isError: isDepartmentError,
    error: departmentError,
    data: departmentData,
  } = useGetDepartmentsQuery({
    params: { skip: 0, limit: 0, is_published: 1 },
  });
  const {
    isLoading: isDesignationLoading,
    data: designationData,
    isError: isDesignationError,
    error: designationError,
  } = useGetDesignationsQuery({
    params: {
      limit: 0,
      skip: 0,
      is_published: 1,
    },
  });
  useError(isEmployeeError, employeeError, "Get employee data fail");
  useError(isDepartmentError, departmentError, "Get department data fail");
  useError(isDesignationError, designationError, "Get designation fail");

  return effective === "employee_type" ? (
    <>
      <span className="text-display-body text-sm font-medium">Target</span>

      <Form.Item
        validateFirst
        name={[index, "target-employee_type"]}
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please select",
          },
        ]}
      >
        <Select
          className="w-full"
          // suffixIcon={<SelectDropdownLgIcon />}
          options={employeeTypeList}
          style={{ width: 140 }}
          popupMatchSelectWidth={180}
          size="small"
          placeholder="Select"
        />
      </Form.Item>
    </>
  ) : effective === "employee" ? (
    <>
      <span className="text-display-body text-sm font-medium">Target</span>

      <Form.Item
        validateFirst
        name={[index, "target-employee"]}
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please select",
          },
        ]}
      >
        <Select
          className="w-full"
          // suffixIcon={<SelectDropdownLgIcon />}
          options={employeeData?.data?.employees?.map((item) => ({
            label: item?.member?.profile?.name,
            value: item?.id,
          }))}
          loading={isEmployeeLoading}
          style={{ width: 160 }}
          popupMatchSelectWidth={250}
          size="small"
          placeholder="Select"
          filterOption={selectSearchOption}
          showSearch
        />
      </Form.Item>
    </>
  ) : effective === "department" ? (
    <>
      <span className="text-display-body text-sm font-medium">Target</span>

      <Form.Item
        validateFirst
        name={[index, "target-department"]}
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please select",
          },
        ]}
      >
        <Select
          className="w-full"
          // suffixIcon={<SelectDropdownLgIcon />}
          options={selectArrayOption(
            departmentData?.data?.departments || [],
            "name",
            "id"
          )}
          loading={isDepartmentLoading}
          style={{ width: 150 }}
          popupMatchSelectWidth={180}
          size="small"
          placeholder="Select"
          filterOption={selectSearchOption}
          showSearch
        />
      </Form.Item>
    </>
  ) : effective === "designation" ? (
    <>
      <span className="text-display-body text-sm font-medium ">Target</span>

      <Form.Item
        validateFirst
        name={[index, "target-designation"]}
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please select",
          },
        ]}
      >
        <Select
          className="w-full"
          // suffixIcon={<SelectDropdownLgIcon />}
          options={
            designationData?.data?.roles?.map((item) => ({
              label: `${item?.name} (${item?.department?.name})`,
              value: item?.id,
            })) || []
          }
          loading={isDesignationLoading}
          style={{ width: 190 }}
          popupMatchSelectWidth={250}
          size="small"
          placeholder="Select"
          filterOption={selectSearchOption}
          showSearch
        />
      </Form.Item>
    </>
  ) : null;
};

const ScheduleType = ({ index, form }: ListComponentType) => {
  const onWhat = Form.useWatch(["package", index, "schedule_type"], form);

  return onWhat === "fixed_date" ? (
    <>
      <span className="text-display-body text-sm font-medium">Schedule</span>

      <Form.Item
        validateFirst
        name={[index, "fixed_date_time"]}
        className="mb-0"
        rules={[
          {
            required: true,
            message: "Please Select",
          },
        ]}
      >
        <DatePicker
          format="MMM YYYY"
          suffixIcon={<DateIcon />}
          picker="month"
          size="small"
          className="clear-button-hide w-[130px]"
        />
      </Form.Item>
    </>
  ) : null;
};

// const dayTypes = [
//   {
//     label: "Holiday",
//     value: "holiday",
//   },
//   {
//     label: "Weekend",
//     value: "weekend",
//   },
//   {
//     label: "Normal",
//     value: "normal",
//   },
// ];

const scheduleTypeList = [
  {
    label: "Fixed Date",
    value: "fixed_date",
  },
  {
    label: "Periodically",
    value: "periodically",
  },
];

const typeListCalculationSelect = [{ label: "Fixed", value: "fixed_amount" }];

const effectiveForList = [
  {
    label: "Global",
    value: "global",
  },
  {
    label: "Employee Type",
    value: "employee_type",
  },
  {
    label: "Employee",
    value: "employee",
  },
  {
    label: "Department",
    value: "department",
  },
  {
    label: "Designation",
    value: "designation",
  },
];
